import api from "@/apis/AllocationReduceLocationAPI";
import Crud from "./crud-base";
var crud = new Crud("AllocationReduceLocation", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "LocationID",
      code: "LocationCode",
      name: "LocationName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const mutations = {
  ...crud.mutations,
};

const actions = {
  ...crud.actions,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
